import React from 'react'

import {t} from '@lib/helpers'

const ICONS = [
  <img
    key='0'
    src='/images/landing/Outcomes__icon--ligthning.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='1'
    src='/images/landing/Outcomes__icon--compass.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='2'
    src='/images/landing/Outcomes__icon--chart.svg'
    alt=''
    width='24'
    height='24'
  />,
  <img
    key='3'
    src='/images/landing/Outcomes__icon--lego.svg'
    alt=''
    width='24'
    height='24'
  />,
]

const Outcomes = () => {
  const items = t('pages.index.landing.outcomes.items') || []

  return (
    <section className='Landing__outcomes'>
      <div className='container'>
        <div className='Landing__outcomes__top'>
          <div className='Landing__outcomes__image'>
            <img
              src='/images/Landing_3.png'
              alt='AI Investment Outcomes'
              loading='lazy'
            />
          </div>
          <div className='Landing__outcomes__content'>
            <span className='Landing__outcomes__label'>
              {t('pages.index.landing.outcomes.label')}
            </span>
            <h2 className='Landing__outcomes__h2'>
              {t('pages.index.landing.outcomes.h2')}
            </h2>
            <p className='Landing__outcomes__desc'>
              {t('pages.index.landing.outcomes.description')}
            </p>
          </div>
        </div>
        <div className='Landing__outcomes__bottom'>
          {Array.isArray(items) &&
            items.map((item, i) => (
              <div className='Landing__outcomes__card' key={item.title}>
                <div className='Landing__outcomes__card__icon'>{ICONS[i]}</div>
                <h4 className='Landing__outcomes__card__title'>{item.title}</h4>
                <p className='Landing__outcomes__card__desc'>
                  {item.description}
                </p>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Outcomes
